import React, { useState } from "react";
import { useSelector } from "react-redux";

import { cn } from "./cn";
import { BellIcon } from "../../../assets/ui/icons";
import { NotificationDrawer } from "../../admin/u1/notifications/NotificationDrawer";
import UserProfileDropdown from "../../public/UserProfileHeader";
import { unreadNotificationCount } from "../../../Hooks/u1/useDashboardNav";

/* The public header's right-hand side, for someone who is signed in — F-110. */
export const SignedInNavActions = ({ className = "" }) => {
  const { userInfo, isLoggedIn } = useSelector((state) => state.auth);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  /* `isLoggedIn` and not `userInfo`: the flag is seeded from localStorage at store init, so it survives a reload, while userInfo is null until the user query... */
  if (!isLoggedIn) return null;

  const unreadCount = unreadNotificationCount(userInfo);

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <button
        type="button"
        onClick={() => setNotificationsOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={notificationsOpen}
        aria-label={
          unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"
        }
        className={cn(
          "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
          "border border-[var(--line)] bg-white text-[var(--ink)] transition-colors",
          "hover:border-[var(--field-border-hover)] focus-visible:outline-none",
          "focus-visible:ring-2 focus-visible:ring-[var(--coral)]"
        )}
      >
        <BellIcon />
        {unreadCount > 0 && (
          <span
            aria-hidden="true"
            className={cn(
              "absolute -right-1 -top-1 flex h-[18px] min-w-[18px] items-center",
              "justify-center rounded-full bg-[var(--coral)] px-1 text-[11px]",
              "font-bold text-white"
            )}
          >
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>

      <NotificationDrawer
        open={notificationsOpen}
        onClose={() => setNotificationsOpen(false)}
      />

      {/* Gated on userInfo, as the dashboard bar gates it: the menu draws the
          account's name and companies, and has nothing to show without them. */}
      {userInfo && <UserProfileDropdown showDetails />}
    </div>
  );
};

export default SignedInNavActions;
